import LogRocket from 'logrocket';
import { ENVIRONMENTS } from '../../types/common/env.dto';
import { getEnvironment } from '../../api/AuthService';
import { getPlatformRegion } from '../../utils/app.utils';

export async function initializeLogRocket() {
  try {
    const envResp = await getEnvironment();
    const region = getPlatformRegion();

    // Logrocket for staging
    if (envResp.data?.envName == ENVIRONMENTS.STAGING_ENV_ID) {
      LogRocket.init('i0bntq/cowbell', {
        dom: {
          inputSanitizer: 'lipsum',
          privateClassNameBlocklist: [REDACTED_FIELD],
        },
      });
    }
    // Logrocket for Dev
    if (
      envResp.data?.envName == ENVIRONMENTS.DEV_ENV_ID ||
      envResp.data?.envName == ENVIRONMENTS.DEV_SPACE
    ) {
      LogRocket.init('i0bntq/cowbell-development-us', {
        dom: {
          inputSanitizer: '',
          privateClassNameBlocklist: [],
        },
      });
    }
    // Logrocket for US-PROD
    if (
      envResp.data?.envName == ENVIRONMENTS.PROD_ENV_ID &&
      region == 'en-US'
    ) {
      LogRocket.init('i0bntq/cowbell-production-us', {
        dom: {
          inputSanitizer: 'lipsum',
          privateClassNameBlocklist: [REDACTED_FIELD],
        },
      });
    }
  } catch (err) {
    console.error('LogRocket failed to initialize');
    console.error(err);
  }
}

/**
 * A constant representing a redacted field identifier.
 * This is used to mark fields that should be redacted in logs or screen replay in LOGROCKET.
 */
export const REDACTED_FIELD = 'cb_redacted_field';
